<template>
  <section id="producto">
    <div class="wrap">
      <div class="section-head">
        <div class="left">
          <span class="eyebrow"><span class="dot"></span>{{ labelsState['lv_features_eyebrow'] || 'Product' }}</span>
          <h2>{{ labelsState['lv_features_heading_pre'] || 'One platform.' }} <span class="grad-text">{{ labelsState['lv_features_heading_grad'] || 'Everything your support needs.' }}</span></h2>
        </div>
        <div class="right">
          {{ labelsState['lv_features_desc'] || 'NQA combines conversational AI, native integrations and automation so your team stops answering repetitive questions and gets back to selling.' }}
        </div>
      </div>
      <div class="features">
        <article v-for="(f, i) in features" :key="i" :class="['feature', { featured: f.featured }]">
          <div class="icon" v-html="f.icon"></div>
          <h3>{{ labelsState[f.titleKey] || f.title }}</h3>
          <p>{{ labelsState[f.bodyKey] || f.body }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useLabelsStore } from '@/stores/labels';
import { useLanguageStore } from '@/stores/language';

const brainIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="22" height="22"><path d="M9.5 2a3 3 0 00-3 3 3 3 0 00-3 3v2a3 3 0 001.5 2.6A3 3 0 003 15v2a3 3 0 003 3 3 3 0 003 3 3 3 0 003-3V5a3 3 0 00-3-3zM14.5 2a3 3 0 013 3 3 3 0 013 3v2a3 3 0 01-1.5 2.6A3 3 0 0121 15v2a3 3 0 01-3 3 3 3 0 01-3 3 3 3 0 01-3-3V5a3 3 0 013-3z"/></svg>`;
const lightningIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="22" height="22"><path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z"/></svg>`;
const linkIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="22" height="22"><path d="M10 13a5 5 0 007 0l3-3a5 5 0 00-7-7l-1 1M14 11a5 5 0 00-7 0l-3 3a5 5 0 007 7l1-1"/></svg>`;
const botIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="22" height="22"><rect x="3" y="8" width="18" height="12" rx="3"/><path d="M12 4v4M9 13h.01M15 13h.01M9 17h6"/><circle cx="12" cy="3" r="1"/></svg>`;
const shieldIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="22" height="22"><path d="M12 2l9 4v6c0 5-3.5 9-9 10-5.5-1-9-5-9-10V6l9-4z"/><path d="M9 12l2 2 4-4"/></svg>`;
const chartIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="22" height="22"><path d="M3 3v18h18M7 14l4-4 4 4 5-6"/></svg>`;

export default {
  name: 'FeaturesV2',
  setup() {
    const labelsStore = useLabelsStore();
    const languageStore = useLanguageStore();
    onMounted(() => labelsStore.fetchAndSetLabels(languageStore.language));
    return { labelsState: computed(() => labelsStore.labels) };
  },
  data() {
    return {
      features: [
        { icon: brainIcon,     titleKey: 'lv_feature_trained_data_title',   title: 'Trained on your data',          bodyKey: 'lv_feature_trained_data_body',   body: 'Upload PDFs, websites, catalogs or connect your CRM. The assistant learns your business in minutes.', featured: true },
        { icon: lightningIcon, titleKey: 'lv_feature_fast_response_title',  title: 'Responses in < 1 second',       bodyKey: 'lv_feature_fast_response_body',  body: 'Ultra-low latency with models optimized for commercial conversation in Spanish.' },
        { icon: linkIcon,      titleKey: 'lv_feature_multichannel_title',   title: 'Native multi-channel',          bodyKey: 'lv_feature_multichannel_body',   body: 'One brain responds on WhatsApp, Instagram, Messenger, web and Telegram.' },
        { icon: botIcon,       titleKey: 'lv_feature_sales_bot_title',      title: 'Schedule and close sales',      bodyKey: 'lv_feature_sales_bot_body',      body: 'Calendar, payments and carts integrated. The bot guides the customer to conversion.' },
        { icon: shieldIcon,    titleKey: 'lv_feature_human_handover_title', title: 'Smooth human handover',         bodyKey: 'lv_feature_human_handover_body', body: 'When things get complex, transfer the conversation to your team with full context.' },
        { icon: chartIcon,     titleKey: 'lv_feature_analytics_title',      title: 'Actionable analytics',          bodyKey: 'lv_feature_analytics_body',      body: 'Conversion metrics, hot FAQs, intent and satisfaction in real time.' },
      ],
    };
  },
};
</script>
